module.exports = {"id":"203671","name":"Juan Ignacio Gomez","rating":"71","photo":"./data/images/photos/4/203671.png","club":{"name":"Cremonese","logo":"./data/images/clubs/Cremonese.png"},"positions":["AD","AG","BU"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JuanIgnacioGomez0.json
// module id = 2214
// module chunks = 0